export default function (http) {
    return {
        queryByName (data){
            return http.json({
                url: '/position/queryAll',
                data
            });
        },
        query (data){
            return http.json({
                url: '/position/query',
                data
            });
        },
        saveInfo(data) {
            return http.json({
                url: `/position/save`,
                data
            })
        },

        getInfo(data){
            return http.json({
                url: '/position/get',
                data
            });
        },
        disable(data){
            return http.json({
                url: '/position/disable',
                data
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/position.js